
export function getRequest( url ) {
  return new Promise(( resolve, reject ) => {
    let req = new XMLHttpRequest();
    req.responseType = 'json';
    req.open( 'GET', url, true );
    req.onload = r => {
      if( r.target.status >= 400 ) {
        reject( r.target.response );
      }
      else {
        resolve( req.response );
      }
    }
    req.onerror = e => {
      reject( e );
    }
    req.send();
  });
}

export function postRequest( url, data = {} ) {
  let send = JSON.stringify( data );
  return new Promise(( resolve, reject ) => {
    let req = new XMLHttpRequest();
    req.responseType = 'json';
    req.open( 'POST', url, true );
    req.setRequestHeader( 'Content-Type', 'application/json;charset=UTF-8' );
    req.setRequestHeader( 'Accept', 'application/json' );
    req.onload = r => {
      if( r.target.status >= 400 ) {
        reject( r.target.response );
      }
      else {
        resolve( req.response );
      }
    }
    req.onerror = e => {
      reject( e );
    }
    req.send( send );
  });
}

export function deleteRequest( url, data = {}) {
  let send = JSON.stringify( data );
  return new Promise(( resolve, reject ) => {
    let req = new XMLHttpRequest();
    req.responseType = 'json';
    req.open( 'DELETE', url, true );
    req.setRequestHeader( 'Content-Type', 'application/json;charset=UTF-8' );
    req.setRequestHeader( 'Accept', 'application/json' );
    req.onload = r => {
      if( r.target.status >= 400 ) {
        reject( r.target.response );
      }
      else {
        resolve( req.response );
      }
    }
    req.onerror = e => {
      reject( e );
    }
    req.send( send );
  });
}

export function patchRequest( url, data = {} ) {
  let send = JSON.stringify( data );
  return new Promise(( resolve, reject ) => {
    let req = new XMLHttpRequest();
    req.responseType = 'json';
    req.open( 'PATCH', url, true );
    req.setRequestHeader( 'Content-Type', 'application/json;charset=UTF-8' );
    req.setRequestHeader( 'Accept', 'application/json' );
    req.onload = r => {
      if( r.target.status >= 400 ) {
        reject( r.target.response );
      }
      else {
        resolve( req.response );
      }
    }
    req.onerror = e => {
      reject( e );
    }
    req.send( send );
  });
}